import React from 'react'

function Alert() {
  return (
    <div>
      <div className="alert alert-warning alert-dismissible fade show" role="alert">
        <strong>Update:</strong> All Resources are now updated for the 2022-23 Exams...All the Best 👍
        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    </div>
  )
}

export default Alert